import React from "react";
import { X, ScrollText } from "lucide-react";

// Shared full-content review modal — click any log row / data point to inspect every field
export const LogDetailModal = ({ title, fields = [], json, onClose }) => (
  <div className="fixed inset-0 z-[100] bg-[#374151]/40 backdrop-blur-sm flex items-center justify-center p-4 animate-overlay-in" data-testid="log-detail-modal" onClick={onClose}>
    <div className="bg-white border border-[#FCE6E9] rounded-[2rem] max-w-lg w-full p-6 shadow-xl animate-modal-in max-h-[90vh] overflow-y-auto dark:bg-[#232D3D] dark:border-[#374457]" onClick={(e) => e.stopPropagation()}>
      <div className="flex justify-between items-center mb-4 pb-3 border-b border-[#FCE6E9] dark:border-[#374457]">
        <h3 className="text-base font-extrabold font-heading text-[#374151] dark:text-slate-100 flex items-center gap-2" data-testid="log-detail-title">
          <span className="w-8 h-8 rounded-full bg-[#E6F2FA] flex items-center justify-center shrink-0">
            <ScrollText className="w-4 h-4 text-[#5CB3DC]" />
          </span>
          {title}
        </h3>
        <button onClick={onClose} data-testid="log-detail-close" className="w-8 h-8 rounded-full flex items-center justify-center text-[#9CA3AF] hover:bg-[#FCE6E9] transition-colors">
          <X className="w-4 h-4" />
        </button>
      </div>
      <div className="space-y-2">
        {fields.map((f) => (
          <div key={f.label} className="flex flex-col gap-0.5 p-2.5 bg-[#FFF9F2] border border-[#FCE6E9] rounded-xl dark:bg-[#273244] dark:border-[#374457]" data-testid={`log-field-${f.label.toLowerCase().replace(/\W+/g, "-")}`}>
            <p className="text-[9px] font-extrabold uppercase tracking-wide text-[#9CA3AF]">{f.label}</p>
            <p className="text-xs font-semibold text-[#374151] dark:text-slate-100 whitespace-pre-wrap break-words">{f.value ?? "—"}</p>
          </div>
        ))}
      </div>
      {json && (
        <div className="mt-3">
          <p className="text-[9px] font-extrabold uppercase tracking-wide text-[#9CA3AF] mb-1">Raw payload</p>
          <pre className="text-[10px] font-mono bg-[#374151] text-emerald-200 rounded-xl p-3 overflow-x-auto whitespace-pre-wrap break-all" data-testid="log-detail-json">
            {typeof json === "string" ? json : JSON.stringify(json, null, 2)}
          </pre>
        </div>
      )}
    </div>
  </div>
);
